import Service from "../Service";
const resource = "HmnVacationsPrograming/";

export default {

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID }
        });
    },
    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    saveApproved(obj, requestID) {
        return Service.post(resource + "saveApproved", obj, {
            params: { requestID: requestID }
        });
    },
    saveApprovedDetail(obj, requestID) {
        return Service.post(resource + "saveApprovedDetail", obj, {
            params: { requestID: requestID }
        });
    },

};